import script from "./AssessedValue.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessedValue.vue?vue&type=script&setup=true&lang=js"

import "./AssessedValue.vue?vue&type=style&index=0&id=24230b57&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24230b57"]])

export default __exports__